/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Views.WebMailSharing = class WebMailSharing {
  constructor(el) {
    this._revealServices = this._revealServices.bind(this);
    this._loadServiceUrl = this._loadServiceUrl.bind(this);
    this.el = el;
    this.revealButton = this.el.find('[data-reveal-services]');
    this.serviceButton = this.el.find('[data-service]');
    this.manualEmailButton = this.el.find('[data-manual-email-button]');
    this.personalMessageEl = this.el.find('[data-personal-message]');
    this.personalSubjectEl = this.el.find('[data-subject]');
    this.shareUrlTextEl = this.el.find('[data-share-url-text]');
    this.clipboardButton = this.el.find('[data-clipboard-button]');

    this.serviceButton.tooltipster({
      position: "top"});

    this.clipboardButton.tooltipster({
      position: "top",
      minWidth: 150
    });

    this.manualEmailButton.tooltipster({
      position: "top"});

    this.serviceButton.on('click', this._loadServiceUrl);
    this.revealButton.on('click', this._revealServices);

    new Buyapowa.Helpers.ManualEmailShare(this.el, this.manualEmailButton, this.personalMessageEl, this.personalSubjectEl, this.shareUrlTextEl);
    new Buyapowa.Views.ClipboardButton(this.clipboardButton);

    this.clipboardButton.on('click', event => {
      const personalMessage = this.personalMessageEl.val();
      this.personalMessageEl.val(this._bodyContent());
      if (!Buyapowa.Helpers.Browser.isSafari() || (Buyapowa.Helpers.Browser.safariVersion() >= 10)) {
        return setTimeout(() => {
          return this.personalMessageEl.val(personalMessage);
        }
        , 1);
      }
    });

    this.clipboardButton.on('click', event => {
      return this._trackEvent($(event.currentTarget).data("track-method"));
    });
  }


  _revealServices(event) {
    event.preventDefault();
    this.revealButton.addClass('hidden');

    return setTimeout(() => {
      return this.revealButton.addClass('behind');
    }
    , 200);
  }

  _loadServiceUrl(event) {
    event.preventDefault();
    const serviceButton = $(event.currentTarget);
    const service = serviceButton.data("service");

    let bodyContent = this._bodyContent();
    let subjectContent = this._subjectContent();
    if (service === "yahoo") {
      bodyContent = bodyContent.replace(/'/g, "’").replace(/"/g, '“');
      subjectContent = subjectContent.replace(/'/g, "’").replace(/"/g, '“');
    }

    const serviceUrl = serviceButton.data('service-url').replace("#BODY#", encodeURIComponent(bodyContent)).replace("#SUBJECT#", encodeURIComponent(subjectContent));

    this._trackEvent(serviceButton.data("track-method"));

    return window.open(serviceUrl);
  }

  _bodyContent() {
    return `${this.personalMessageEl.val()} \n\n${this.shareUrlTextEl.val()}`;
  }

  _subjectContent() {
    return `${this.personalSubjectEl.val()}`;
  }

  _trackEvent(trackMethod) {
    return eval(trackMethod + "()");
  }
};
